import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import httpMethod from 'services/update2025/httpMethod';

import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";

import { findIdpAdminEventLogs } from "services/IdpAdminEventLogService";
import { IdpAdminEventLogContext } from "components/idp-admin-event-log/IdpAdminEventLogContext";
import { X_TOTAL_COUNT } from "utils/constants";
import { handleError } from "utils/handleError";
import moment from "moment";

export const IdpAdminEventLogList = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["idp-admin-event-log", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const idpAdminEventLogContext = useContext(IdpAdminEventLogContext);
    const { idpAdminEventLogs, setIdpAdminEventLogs } = idpAdminEventLogContext;

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            operationType: { value: "", matchMode: "contains" },
            realmId: { value: "", matchMode: "contains" },
            resourceType: { value: "", matchMode: "contains" },
        },
    });
    const [globalFilter, setGlobalFilter] = useState(null);

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        findIdpAdminEventLogs(headers, lazyParams)
            .then((res) => {
                setTotalRecords(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                setIdpAdminEventLogs(res.data);
            })
            .catch((error) => handleError(toast, t, error))
            .finally(() => {
                setLoading(false);
            });
    };

    const onPage = (event) => {
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onSort = (event) => {
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onFilter = (event) => {
        let _lazyParams = { ...lazyParams, ...event };
        _lazyParams["first"] = 0;
        setLazyParams(_lazyParams);
    };

    const textFilterTemplate = (options) => {
        return (
            <div className="flex align-items-center justify-content-center">
                <InputText value={options.value} onChange={(e) => options.filterApplyCallback(e.target?.value || "")} />
            </div>
        );
    };

    const timeBodyTemplate = (rowData) => {
        return (
            <>
                <div className="flex">
                    <p>{moment(rowData.time).format("DD/MM/YYYY HH:mm:ss")}</p>
                </div>
            </>
        );
    };

    const headerTemplate = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">{t("idpAdminEventLog.list")}</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder={t("search", {ns: "common"})}/>
            </span> */}
        </div>
    );

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />

                    <DataTable
                        ref={dt}
                        value={idpAdminEventLogs}
                        dataKey="id"
                        className="datatable-responsive p-datatable-sm"
                        globalFilter={globalFilter}
                        header={headerTemplate}
                        showGridlines
                        lazy
                        paginator
                        rows={lazyParams.rows}
                        rowsPerPageOptions={[10, 20, 50]}
                        first={lazyParams.first}
                        totalRecords={totalRecords}
                        onPage={onPage}
                        onSort={onSort}
                        sortField={lazyParams.sortField}
                        sortOrder={lazyParams.sortOrder}
                        onFilter={onFilter}
                        filters={lazyParams.filters}
                        loading={loading}
                    >
                        <Column field="realmId" header={t("realmId")} sortable filter showFilterMatchModes={false} filterElement={textFilterTemplate} />
                        <Column field="operationType" header={t("operationType")} sortable filter showFilterMatchModes={false} filterElement={textFilterTemplate} />
                        <Column field="resourceType" header={t("resourceType")} sortable filter showFilterMatchModes={false} filterElement={textFilterTemplate} />
                        <Column field="time" header={t("time")} sortable filterElement={textFilterTemplate} body={timeBodyTemplate} />
                        <Column field="authDetails.ipAddress" header={t("ipAddress")} filterElement={textFilterTemplate} />
                        <Column field="authDetails.clientId" header={t("clientId")} filterElement={textFilterTemplate} />
                        <Column field="authDetails.userId" header={t("userId")} filterElement={textFilterTemplate} />
                        <Column field="resourcePath" header={t("resourcePath")} filterElement={textFilterTemplate} />
                    </DataTable>
                </div>
            </div>
        </div>
    );
};
